<template>
  <div>
    <div :class="[grayFlag ? 'download gray_flag' : 'download']">
      <img class="logo" :src="require('../../assets/logo_200.png')" />
      <div class="text">
        <h3>家慧库</h3>
        <p>用爱温暖全球每个家庭</p>
      </div>
      <div class="button" @click="downloadApp">
        {{ myTitle || '立即下载' }}
      </div>
    </div>
    <div class="prompts" v-show="show" @click="show = false">
      <img src="~@/assets/images/url-app.png" />
      <p>点击右上角，选择在浏览器打开</p>
    </div>
  </div>
</template>

<script>
import Home from '@/models/home'
import Env from '@/config/env'
import user from '@/models/user'
export default {
  name: 'AppDownload',
  props: ['myTitle'],
  data() {
    return {
      show: false,
      grayFlag: false // 页面置灰控制入口
    }
  },
  methods: {
    async downloadApp() {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isAndroid) {
        if (Env.mobileUrlList.indexOf(window.location.hostname) !== -1) {
          window.location.href =
            'https://a.app.qq.com/o/simple.jsp?pkgname=com.yizhilu.zhuoyueparent'
        } else {
          if (this.utils.isWeiXin()) {
            this.show = true
            return
          }
          const res = await Home.getUpdaterApp()
          window.location.href = res.data.url
        }
      } else if (isiOS) {
        if (Env.mobileUrlList.indexOf(window.location.hostname) !== -1) {
          window.location.href = 'https://apps.apple.com/cn/app/id1094638253'
        } else {
          if (this.utils.isWeiXin()) {
            this.show = true
            return
          }
          window.location.href = 'https://fir.im/btmu'
        }
      } else {
        this.$toast('未知设备')
      }
    }
  },
  mounted() {
    // 获取页面置灰配置
    user.getTurnGreyConfig().then(res => {
      if (res.status === 200 && res.data) {
        if (res.data.status === 1) {
          this.grayFlag = true
        }
      }
    })
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/global.less';

.download {
  transition: all 0.3s;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 100 / @r;
  width: 100%;
  background: #fff;
  z-index: 99;
  display: flex;
  align-items: center;
  border-top: 1px solid #f4f4f4;
  padding-bottom: calc(env(safe-area-inset-bottom) / 2);
  .logo {
    width: 68 / @r;
    height: 68 / @r;
    border-radius: 8px;
    border: 1px solid #dadada;
    margin: 0 20 / @r 0 36 / @r;
  }

  .text {
    flex: 1;
    h3 {
      margin: 0;
      font-weight: 400;
      font-size: 26 / @r;
    }
    p {
      margin: 0;
      font-size: 26 / @r;
      color: #333;
      font-weight: 600;
    }
  }
  .button {
    text-align: center;
    font-size: 24 / @r;
    width: 146 / @r;
    height: 56 / @r;
    margin-right: 30 / @r;
    font-weight: 600;
    line-height: 56 / @r;
    background: #94252a;
    box-shadow: 0 / @r 10 / @r 30 / @r 0 / @r rgba(99, 17, 21, 0.3);
    border-radius: 28 / @r;
    color: #fff;
  }
}

.prompts {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  p {
    color: #fff;
    font-size: 40 / @r;
    text-align: center;
    margin: 0;
  }
  img {
    width: 97%;
    margin: auto;
  }
}
.gray_flag {
  -webkit-filter: grayscale(1); /* Webkit */
  filter: gray; /* IE6-9 */
  filter: grayscale(1);
}
</style>
